import { render, staticRenderFns } from "./AddRNReport.vue?vue&type=template&id=be7c54c6&"
import script from "./AddRNReport.vue?vue&type=script&lang=js&"
export * from "./AddRNReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports